(function () {
  /* 2026-08-11: 전달자 제거 — 이 페이지가 곧 게임 페이지다(템플릿 skin-fortune-v51).
     되살리면 프록시의 navigate-302 와 물려 무한 리로드가 난다(실측 15초에 문서요청 50회). */

  var roots = document.querySelectorAll('[data-klairs-skin-fortune-v5]');
  if (!roots.length) return;

  document.body.classList.add('klairs-skin-fortune-v5-page');
  suppressRewardOverlays();
  window.setTimeout(suppressRewardOverlays, 800);
  window.setTimeout(suppressRewardOverlays, 2400);
  if (window.MutationObserver) {
    new MutationObserver(suppressRewardOverlays).observe(document.body, { childList: true, subtree: true });
  }

  var STORAGE_PREFIX = 'klairsSkinFortuneV5';
  var API_TODAY = '/apps/skin-fortune/today';
  var API_PLAY = '/apps/skin-fortune/play';
  var REVEAL_THRESHOLD = 68;
  var progressBuckets = [15, 35, 55, 68];

  var oracleSigns = [
    { slug: 'reset', name: 'The Reset', symbol: '☾', motif: 'A serene crescent moon over still water.' },
    { slug: 'glow', name: 'The Glow', symbol: '☼', motif: 'A soft radiant sun with dewy light rays.' },
    { slug: 'drink', name: 'The Drink', symbol: '◌', motif: 'A luminous water droplet with gentle ripples.' },
    { slug: 'shield', name: 'The Shield', symbol: '◇', motif: 'A translucent shield of light.' },
    { slug: 'calm', name: 'The Calm', symbol: '✧', motif: 'Centella leaves resting in a calm mist.' },
    { slug: 'bloom', name: 'The Bloom', symbol: '✿', motif: 'Fresh petals opening slowly.' },
    { slug: 'balance', name: 'The Balance', symbol: '◐', motif: 'Oil and water pearls in balance.' },
    { slug: 'fresh', name: 'The Fresh', symbol: '✺', motif: 'A bright citrus spark.' },
    { slug: 'deep', name: 'The Deep', symbol: '≋', motif: 'Deep blue hydration.' },
    { slug: 'night', name: 'The Night', symbol: '✦', motif: 'A quiet starry ritual.' },
    { slug: 'spark', name: 'The Spark', symbol: '✷', motif: 'A small burst of energy.' },
    { slug: 'rare-moon', name: 'The Rare Moon', symbol: '●', motif: 'A full golden holographic moon.' }
  ];

  var skinSigns = [
    'The Calm',
    'The Shield',
    'The Glow',
    'The Drink',
    'The Reset',
    'The Night',
    'The Balance',
    'The Fresh'
  ];

  var careSigns = [
    'Layer lightly today.',
    'Let your skin rest.',
    'Prep before you treat.',
    'Hydrate, then pause.',
    'Keep the routine quiet.',
    'Choose comfort first.',
    'Press, do not rush.',
    'Seal the simple steps.'
  ];

  var fortunes = [
    'Today favors doing less.',
    'A slower routine suits your skin today.',
    'Good day to keep it simple.',
    'Your glow likes patience today.',
    'The calm step is the lucky step.',
    'A gentle rhythm wins today.',
    'Let your routine breathe.',
    'Small care, repeated well, is the signal.',
    'Your skin sign points toward comfort.',
    'A quiet night routine has good luck.'
  ];

  var missions = [
    'Do your PM steps before 11pm.',
    'Add one hydration layer today.',
    'Patch test before you commit.',
    'Give each layer time to settle.',
    'Skip one unnecessary experiment.',
    'Use lukewarm water tonight.',
    'Press toner in gently.',
    'Keep the routine under five steps.',
    'Apply sunscreen before the first scroll.',
    'Write down how your skin feels today.'
  ];

  var scratchHints = [
    { max: 15, text: 'The silver is starting to give.' },
    { max: 35, text: 'A little more — the pull is still hiding.' },
    { max: 55, text: 'Your ticket is waking up.' },
    { max: 68, text: 'Almost there.' },
    { max: 100, text: 'Opening the skin fortune.' }
  ];

  roots.forEach(init);
  injectSkinReadinessFallback(roots[0]);

  function init(root) {
    var canvas = root.querySelector('[data-scratch-canvas]');
    var wrap = root.querySelector('[data-scratch-wrap]');
    if (!canvas || !wrap) return;

    var state = {
      root: root,
      canvas: canvas,
      ctx: canvas.getContext('2d', { willReadFrequently: true }),
      wrap: wrap,
      customerKey: root.getAttribute('data-customer-key') || 'guest',
      liquidLoggedIn: root.getAttribute('data-logged-in') === 'true',
      serverMode: false,
      serverReady: root.getAttribute('data-logged-in') !== 'true',
      serverToday: null,
      today: todayKey(),
      pendingResult: null,
      pendingStreak: 1,
      scratchScore: 0,
      drawing: false,
      opened: false,
      emittedBuckets: {},
      lastPoint: null,
      foilImage: null,
      reducedMotion: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    };

    state.storageKey = STORAGE_PREFIX + ':streak:' + state.customerKey;
    state.playKey = STORAGE_PREFIX + ':play:' + state.customerKey + ':' + state.today;
    state.collectionKey = STORAGE_PREFIX + ':oracleDeck:' + state.customerKey;
    state.streak = readStreak(state.storageKey);
    state.pendingStreak = getPendingStreak(state.streak, state.today);

    root.__klairsSkinFortuneV5 = {
      reset: function () {
        localStorage.removeItem(state.playKey);
        setRootState(root, 'sealed');
        updateStreakBadge(state, false);
        resetScratch(state);
      },
      reveal: function () {
        beginOpening(state);
      }
    };

    updateDate(root, state.today);
    updateCountdown(root);
    setInterval(function () { updateCountdown(root); }, 1000);
    updateStreakBadge(state, false);
    renderCollection(state, null);
    bindControls(state);
    loadFoil(state);
    resizeCanvas(state);
    window.addEventListener('resize', function () { resizeCanvas(state); });

    initPlayState(state);

    emit(root, 'view', { state: rootState(root), streak: state.streak.streakCount || 0 });
  }

  function initPlayState(state) {
    setPlayLoading(state, true);
    fetchJSON(API_TODAY, { method: 'GET' })
      .then(function (payload) {
        if (payload && payload.next_reset_iso) {
          state.nextResetISO = payload.next_reset_iso;
          state.root.setAttribute('data-next-reset-iso', payload.next_reset_iso);
          updateCountdown(state.root);
        }

        if (!payload || payload.logged_in === false) {
          state.serverMode = false;
          renderLocalEntry(state);
          return;
        }

        state.serverMode = true;
        state.serverToday = payload;
        syncServerStreak(state, payload.streak, !!payload.played_today);
        updateStreakBadge(state, false);
        if (payload.played_today && payload.last) {
          renderLocked(state, normalizeServerResult(payload.last, payload));
        } else {
          setRootState(state.root, 'sealed');
          setStageCopy(state.root, serverStreakCount(payload.streak) > 0 ? 'Don’t break your ' + serverStreakCount(payload.streak) + '-day streak.' : "Start when you're ready.");
        }
        emit(state.root, 'server_today', { played_today: !!payload.played_today, streak: serverStreakCount(payload.streak) });
      })
      .catch(function () {
        state.serverMode = false;
        renderLocalEntry(state);
      })
      .finally(function () {
        state.serverReady = true;
        setPlayLoading(state, false);
      });
  }

  function renderLocalEntry(state) {
    var stored = safeJSON(localStorage.getItem(state.playKey));
    if (stored && stored.result) {
      renderLocked(state, stored.result);
    } else {
      setRootState(state.root, 'sealed');
      setStageCopy(state.root, state.pendingStreak > 1 ? 'Don’t break your ' + state.streak.streakCount + '-day streak.' : "Start when you're ready.");
    }
  }

  function bindControls(state) {
    var root = state.root;
    var start = root.querySelector('[data-start-button]');
    var finish = root.querySelector('[data-finish-button]');
    var tomorrow = root.querySelector('[data-tomorrow-button]');
    var shop = root.querySelector('[data-shop-link]');
    var claim = root.querySelector('[data-claim-link]');
    var save = root.querySelector('[data-save-note]');

    if (start) {
      start.addEventListener('click', function () {
        armTicket(state);
      });
    }

    if (finish) {
      finish.addEventListener('click', function () {
        if (state.opened) return;
        emit(root, 'finish_scratch', { percent: currentScratchPercent(state) });
        beginOpening(state);
      });
    }
    if (finish) finish.textContent = 'See today’s fortune';

    if (tomorrow) {
      tomorrow.addEventListener('click', function () {
        updateCountdown(root);
        tomorrow.blur();
      });
    }

    if (shop) {
      shop.addEventListener('click', function () {
        emit(root, 'shop_click', { tier: root.getAttribute('data-tier') || 'unknown' });
      });
    }

    if (claim) {
      claim.addEventListener('click', function () {
        emit(root, 'claim_click', { tier: root.getAttribute('data-tier') || 'unknown' });
      });
    }

    if (save) {
      save.addEventListener('click', function () {
        shareFortune(root, save);
        emit(root, 'share_fortune', { tier: root.getAttribute('data-tier') || 'unknown' });
      });
    }

    state.canvas.addEventListener('mousedown', function (event) { startScratch(state, event); });
    state.canvas.addEventListener('mousemove', function (event) { moveScratch(state, event); });
    window.addEventListener('mouseup', function () { stopScratch(state); });
    state.canvas.addEventListener('touchstart', function (event) { startScratch(state, event); }, { passive: false });
    state.canvas.addEventListener('touchmove', function (event) { moveScratch(state, event); }, { passive: false });
    state.canvas.addEventListener('touchend', function () { stopScratch(state); });
  }

  function armTicket(state) {
    if (state.opened) return;
    if (state.liquidLoggedIn && !state.serverReady) {
      setStageCopy(state.root, 'Checking today’s ticket.');
      return;
    }
    setRootState(state.root, 'armed');
    setTicketState(state.root, 'ARMED');
    setStageCopy(state.root, 'Scratch slowly.');
    state.root.querySelector('[data-scratch-hint]').textContent = scratchHints[0].text;
    emit(state.root, 'start', { streak_target: state.pendingStreak });
    vibrate(18);
  }

  function setPlayLoading(state, isLoading) {
    var start = state.root.querySelector('[data-start-button]');
    state.root.classList.toggle('is-syncing', !!isLoading);
    if (start) {
      start.disabled = !!isLoading;
      start.textContent = isLoading ? 'Checking today’s ticket' : 'Start scratching';
    }
    if (isLoading) {
      setTicketState(state.root, 'SYNC');
      setStageCopy(state.root, 'Checking today’s ticket.');
    } else if (!state.root.classList.contains('is-locked')) {
      setTicketState(state.root, 'SEALED');
    }
  }

  function startScratch(state, event) {
    if (state.opened) return;
    if (!state.root.classList.contains('is-armed')) armTicket(state);
    event.preventDefault();
    state.drawing = true;
    state.lastPoint = pointerPosition(state, event);
    setRootState(state.root, 'scratching');
    drawScratch(state, state.lastPoint, state.lastPoint);
    emit(state.root, 'scratch_start', {});
  }

  function moveScratch(state, event) {
    if (!state.drawing || state.opened) return;
    event.preventDefault();
    var point = pointerPosition(state, event);
    drawScratch(state, state.lastPoint || point, point);
    state.lastPoint = point;
    var percent = currentScratchPercent(state);
    updateScratchUI(state, percent);
    if (percent >= REVEAL_THRESHOLD) beginOpening(state);
  }

  function stopScratch(state) {
    state.drawing = false;
    state.lastPoint = null;
  }

  var READING_LINES = [
    'Reading the silver…',
    'Listening to your skin…',
    'Aligning today’s sign…',
    'Your fortune is forming…'
  ];

  function setReadingText(root, text) {
    var el = root.querySelector('[data-reading-text]');
    if (el) el.textContent = text;
  }

  function startReadingSuspense(state) {
    var root = state.root;
    root.classList.add('is-reading');
    setReadingText(root, READING_LINES[0]);
    if (state.reducedMotion) return;
    var i = 0;
    state.readingTimer = window.setInterval(function () {
      i = (i + 1) % READING_LINES.length;
      setReadingText(root, READING_LINES[i]);
    }, 1150);
  }

  function stopReadingSuspense(state) {
    if (state.readingTimer) { window.clearInterval(state.readingTimer); state.readingTimer = null; }
    state.root.classList.remove('is-reading');
  }

  function beginOpening(state) {
    if (state.opened) return;
    state.opened = true;
    state.root.classList.remove('is-scratching');
    state.root.classList.add('is-near-reveal');
    setRootState(state.root, 'opening');
    setTicketState(state.root, 'READING');
    setStageCopy(state.root, 'Reading your fortune…');
    emit(state.root, 'opening', { percent: Math.round(currentScratchPercent(state)) });
    vibrate([24, 34, 24]);

    // 스크래치 이후 "포춘 생성 중" 서스펜스(최소 4s) — mock/server 공통. 결과는 그동안 준비됨.
    startReadingSuspense(state);
    var minReveal = state.reducedMotion ? 160 : 4000;
    var wait = new Promise(function (res) { window.setTimeout(res, minReveal); });
    Promise.all([resolvePlay(state), wait]).then(function (arr) {
      stopReadingSuspense(state);
      reveal(state, arr[0]);
    });
  }

  function resolvePlay(state) {
    if (!state.serverMode) {
      state.pendingResult = state.pendingResult || createGuestResult(state.pendingStreak);
      return Promise.resolve(state.pendingResult);
    }

    return fetchJSON(API_PLAY, { method: 'POST' })
      .then(function (payload) {
        if (!payload || payload.logged_in === false) {
          var fallback = createGuestResult(state.pendingStreak);
          fallback.requiresLogin = true;
          fallback.label = payload && payload.label ? payload.label : fallback.label;
          fallback.fortune = payload && payload.message ? payload.message : 'Your fortune is ready — log in to keep it and claim.';
          return fallback;
        }
        if (payload.already_played && payload.last) {
          return normalizeServerResult(payload.last, payload);
        }
        return normalizeServerResult(payload, payload);
      })
      .catch(function () {
        var fallback = createGuestResult(state.pendingStreak);
        fallback.requiresLogin = false;
        fallback.fortune = 'Something slipped — pull again in a moment.';
        return fallback;
      });
  }

  function reveal(state, result) {
    var root = state.root;
    var newStreak = result.serverStreak
      ? normalizeStreakObject(result.serverStreak, state.today, state.streak.longestStreak)
      : {
        lastPlayDate: state.today,
        streakCount: state.pendingStreak,
        longestStreak: Math.max(state.pendingStreak, state.streak.longestStreak || 0)
      };

    renderResult(root, result, false);
    markDiscovered(state, result);
    if (!state.serverMode) {
      localStorage.setItem(state.storageKey, JSON.stringify(newStreak));
      localStorage.setItem(state.playKey, JSON.stringify({
        date: state.today,
        result: result,
        streakCount: newStreak.streakCount
      }));
    }

    state.streak = newStreak;
    updateStreakBadge(state, true);
    renderCollection(state, result);
    setRootState(root, 'revealed');
    setTicketState(root, result.label.toUpperCase());
    setStageCopy(root, 'Your fortune is ready.');
    root.setAttribute('data-tier', result.tier);

    if (result.rewardUrl) updateShopLink(root, result.rewardUrl);
    updateRewardActions(root, result);
    root.classList.toggle('needs-login-claim', !!result.requiresLogin);

    if (result.burst) createBurst(root, result.rewardKind === 'fullsize' || result.tier === 'bluemoon' ? 34 : 20);

    emit(root, 'reveal', { tier: result.tier, points: result.points, reward_kind: result.rewardKind, streak: newStreak.streakCount });
    emit(root, 'reward_tier', { tier: result.tier, points: result.points, reward_kind: result.rewardKind });
    emit(root, 'streak_day', { streak: newStreak.streakCount, longest: newStreak.longestStreak });
  }

  function renderLocked(state, result) {
    renderResult(state.root, result, true);
    renderCollection(state, result);
    state.root.setAttribute('data-tier', result.tier || 'common');
    setRootState(state.root, 'locked');
    setTicketState(state.root, 'OPENED');
    setStageCopy(state.root, result.household ? 'Today’s fortune was already opened at your address.' : 'You’ve opened today’s fortune.');
    if (result.rewardUrl) updateShopLink(state.root, result.rewardUrl);
    updateRewardActions(state.root, result);
    state.root.classList.toggle('needs-login-claim', !!result.requiresLogin);
    updateCountdown(state.root);
    updateStreakBadge(state, false);
    emit(state.root, 'return_locked', { tier: result.tier || 'unknown', streak: state.streak.streakCount || 0 });
  }

  function renderResult(root, result, locked) {
    root.setAttribute('data-reward-kind', result.rewardKind || 'none');
    root.setAttribute('data-reward-status', result.rewardStatus || 'none');
    root.setAttribute('data-oracle-sign', result.signSlug || 'reset');
    setText(root, '[data-result-tier]', result.label || 'Skin Note');
    setText(root, '[data-result-reward]', result.reward || rewardDisplay(result.rewardKind, result.points, result.rewardDetail));
    setText(root, '[data-skin-sign]', result.skinSign || result.label || 'Today’s note');
    setText(root, '[data-care-sign]', result.fortune || result.careSign || 'Today favors doing less.');
    setText(root, '[data-reward-label]', result.mission || 'Add one hydration layer today.');
    setText(root, '[data-oracle-symbol]', result.signSymbol || '☾');
    setText(root, '[data-fortune-text]', result.fortune || 'Today favors doing less.');
    setText(root, '[data-mission-text]', '🧴 Today’s ritual · ' + (result.mission || 'Add one hydration layer today.'));
    setText(root, '[data-reward-note]', rewardNote(result, locked));
    setText(root, '[data-streak-gain]', locked ? 'Today’s streak is saved.' : '🔥 streak +1');
  }

  function createGuestResult(pendingStreak) {
    var sign = signFromName(pick(skinSigns));
    return {
      date: todayKey(),
      tier: 'common',
      label: sign.name,
      reward: 'Skin note only',
      rewardKind: 'none',
      rewardStatus: 'none',
      rewardDetail: '',
      points: 0,
      claim: false,
      skinSign: sign.name,
      signSlug: sign.slug,
      signSymbol: sign.symbol,
      careSign: pick(careSigns),
      fortune: pick(fortunes),
      mission: pick(missions),
      burst: false,
      pendingStreak: pendingStreak
    };
  }

  function normalizeServerResult(payload, envelope) {
    var source = payload || {};
    var tier = normalizeTier(source.tier || source.reward_tier || 'common');
    var points = Number(source.points_awarded || 0);
    var rewardKind = normalizeRewardKind(source.reward_kind, tier);
    var rewardStatus = source.reward_status || (rewardKind === 'none' ? 'none' : 'pending');
    var rewardDetail = source.reward_detail || '';
    var sign = resolveOracleSign(source, tier);
    var label = source.label || sign.name || titleize(tier);
    var rewardText = source.reward || source.reward_label || rewardDisplay(rewardKind, points, rewardDetail);
    return {
      date: todayKey(),
      tier: tier,
      label: label,
      reward: rewardText,
      points: points,
      rewardKind: rewardKind,
      rewardStatus: rewardStatus,
      rewardDetail: rewardDetail,
      claim: rewardKind === 'miniature' || rewardKind === 'fullsize',
      requiresLogin: source.logged_in === false || (envelope && envelope.logged_in === false),
      skinSign: sign.name || source.skin_sign || source.skinSign || source.sign || label,
      signSlug: sign.slug,
      signSymbol: sign.symbol,
      discoveredSigns: source.discovered_signs || source.discoveredSigns || (envelope && (envelope.discovered_signs || envelope.discoveredSigns)),
      careSign: source.message || source.care_sign || source.careSign || source.care || 'Open today’s care sign.',
      fortune: source.message || source.fortune || 'Today’s skin fortune is open.',
      mission: source.mission || 'Come back tomorrow for a fresh pull.',
      burst: rewardKind === 'miniature' || rewardKind === 'fullsize' || rewardKind === 'points',
      rewardUrl: source.reward_url || source.rewardUrl || (envelope && (envelope.reward_url || envelope.rewardUrl)) || '',
      serverStreak: source.streak || (envelope && envelope.streak),
      household: !!(source.household_limited || (envelope && envelope.household_limited))
    };
  }

  function fetchJSON(url, options) {
    var opts = options || {};
    opts.credentials = 'same-origin';
    opts.headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    if (opts.method === 'POST') {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = opts.body || '{}';
    }
    return fetch(url, opts).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        if (response.status === 409 && payload) {
          payload.already_played = payload.already_played !== false;
          return payload;
        }
        if (!response.ok) throw payload || response;
        return payload;
      });
    });
  }

  function loadFoil(state) {
    var url = state.canvas.getAttribute('data-foil-url');
    if (!url) return;
    var img = new Image();
    img.onload = function () {
      state.foilImage = img;
      resizeCanvas(state);
    };
    img.src = url;
  }

  function resizeCanvas(state) {
    var rect = state.wrap.getBoundingClientRect();
    var ratio = window.devicePixelRatio || 1;
    state.canvas.width = Math.max(1, Math.floor(rect.width * ratio));
    state.canvas.height = Math.max(1, Math.floor(rect.height * ratio));
    state.canvas.style.width = rect.width + 'px';
    state.canvas.style.height = rect.height + 'px';
    state.ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    drawCover(state, rect.width, rect.height);
  }

  function resetScratch(state) {
    state.opened = false;
    state.pendingResult = null;
    state.emittedBuckets = {};
    state.scratchScore = 0;
    state.pendingStreak = getPendingStreak(state.streak, state.today);
    resizeCanvas(state);
    updateScratchUI(state, 0);
    setTicketState(state.root, 'SEALED');
    setStageCopy(state.root, "Start when you're ready.");
  }

  function drawCover(state, width, height) {
    var ctx = state.ctx;
    ctx.globalCompositeOperation = 'source-over';
    ctx.globalAlpha = 1;
    ctx.clearRect(0, 0, width, height);

    var gradient = ctx.createLinearGradient(0, 0, width, height);
    gradient.addColorStop(0, '#c9d8e8');
    gradient.addColorStop(0.28, '#f7fbff');
    gradient.addColorStop(0.56, '#bdd2e7');
    gradient.addColorStop(1, '#f8fbff');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);

    if (state.foilImage && state.foilImage.complete) {
      ctx.globalAlpha = 0.48;
      var pattern = ctx.createPattern(state.foilImage, 'repeat');
      if (pattern) {
        ctx.fillStyle = pattern;
        ctx.fillRect(0, 0, width, height);
      }
      ctx.globalAlpha = 1;
    }

    ctx.fillStyle = 'rgba(255, 255, 255, 0.26)';
    for (var i = -height; i < width; i += 62) {
      ctx.save();
      ctx.translate(i, 0);
      ctx.rotate(-0.36);
      ctx.fillRect(0, 0, 18, height * 2);
      ctx.restore();
    }

    ctx.fillStyle = 'rgba(20, 95, 210, 0.1)';
    ctx.font = '800 11px sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText('SCRATCH SLOWLY', width / 2, height / 2);
  }

  function drawScratch(state, from, to) {
    var ctx = state.ctx;
    var brush = Math.max(28, Math.min(44, state.canvas.clientWidth * 0.095));
    var distance = Math.hypot(to.x - from.x, to.y - from.y);
    state.scratchScore += Math.max(brush * 0.7, distance * brush * 1.32);
    ctx.save();
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.lineWidth = brush;
    ctx.beginPath();
    ctx.moveTo(from.x, from.y);
    ctx.lineTo(to.x, to.y);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(to.x, to.y, brush * 0.42, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
    if (!state.reducedMotion) spawnScratchParticle(state, to);
  }

  function spawnScratchParticle(state, point) {
    if (Math.random() > 0.38) return;
    var particle = document.createElement('span');
    particle.className = 'ksf-v5__scratch-speck';
    particle.style.left = point.x + 'px';
    particle.style.top = point.y + 'px';
    particle.style.setProperty('--dx', (Math.random() * 34 - 17) + 'px');
    particle.style.setProperty('--dy', (-12 - Math.random() * 24) + 'px');
    state.wrap.appendChild(particle);
    window.setTimeout(function () { particle.remove(); }, 700);
  }

  function currentScratchPercent(state) {
    var ctx = state.ctx;
    var canvas = state.canvas;
    var pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    var clear = 0;
    for (var i = 3; i < pixels.length; i += 4) {
      if (pixels[i] < 24) clear += 1;
    }
    var pixelPercent = clear / (pixels.length / 4) * 100;
    var area = Math.max(1, state.canvas.clientWidth * state.canvas.clientHeight);
    var pathPercent = Math.min(100, state.scratchScore / (area * 0.62) * 100);
    return Math.max(pixelPercent, pathPercent);
  }

  function updateScratchUI(state, percent) {
    var root = state.root;
    var meter = root.querySelector('[data-seal-meter]');
    var hint = root.querySelector('[data-scratch-hint]');
    if (meter) meter.style.width = Math.min(100, percent / REVEAL_THRESHOLD * 100) + '%';
    if (hint) hint.textContent = hintFor(percent);
    root.classList.toggle('is-near-reveal', percent >= 56);

    progressBuckets.forEach(function (bucket) {
      if (percent >= bucket && !state.emittedBuckets[bucket]) {
        state.emittedBuckets[bucket] = true;
        emit(root, 'scratch_progress', { bucket: bucket, percent: Math.round(percent) });
      }
    });
  }

  function pointerPosition(state, event) {
    var point = event.touches ? event.touches[0] : event;
    var rect = state.canvas.getBoundingClientRect();
    return {
      x: Math.max(0, Math.min(rect.width, point.clientX - rect.left)),
      y: Math.max(0, Math.min(rect.height, point.clientY - rect.top))
    };
  }

  function setRootState(root, state) {
    ['sealed', 'armed', 'scratching', 'opening', 'revealed', 'locked'].forEach(function (name) {
      root.classList.toggle('is-' + name, name === state);
    });
  }

  function rootState(root) {
    var states = ['sealed', 'armed', 'scratching', 'opening', 'revealed', 'locked'];
    for (var i = 0; i < states.length; i += 1) {
      if (root.classList.contains('is-' + states[i])) return states[i];
    }
    return 'sealed';
  }

  function updateStreakBadge(state, animate) {
    var root = state.root;
    var playedToday = state.streak && state.streak.lastPlayDate === state.today;
    var continuedFromYesterday = state.streak && isYesterday(state.streak.lastPlayDate, state.today);
    var shown = playedToday
      ? state.streak.streakCount
      : (continuedFromYesterday ? state.streak.streakCount : 0);
    var rootStateName = rootState(root);
    var ticketText;
    var topStrong;
    var topLabel = 'skin streak';
    var aria;

    if (playedToday) {
      ticketText = 'Day ' + state.streak.streakCount + ' streak 🔥';
      if (rootStateName === 'locked') ticketText += ' · Next pull in ' + countdownShort(root);
      topStrong = 'Day ' + state.streak.streakCount;
      aria = state.streak.streakCount + ' day streak';
    } else if (continuedFromYesterday && shown > 0) {
      ticketText = 'Day ' + shown + ' streak 🔥 — don’t break it today.';
      topStrong = 'Day ' + shown;
      aria = shown + ' day streak, do not break it today';
    } else {
      ticketText = 'Start your streak today 🔥';
      topStrong = 'Start';
      topLabel = 'your streak today';
      aria = 'Start your streak today';
    }

    setText(root, '[data-streak-count]', topStrong);
    var topBadge = root.querySelector('[data-streak-badge] span:last-child');
    if (topBadge) topBadge.textContent = topLabel;
    var ticket = root.querySelector('[data-ticket-streak]');
    if (ticket) {
      ticket.textContent = ticketText;
      ticket.setAttribute('aria-label', aria);
    }
    setText(root, '[data-streak-milestone]', milestoneText(playedToday ? state.streak.streakCount : state.pendingStreak));
    updateMoonMeter(root, playedToday ? state.streak.streakCount : state.pendingStreak);
    var gain = root.querySelector('[data-streak-gain]');
    if (gain) gain.textContent = animate ? 'Day ' + state.streak.streakCount + ' streak 🔥' : 'Today’s streak is saved.';
  }

  function updateMoonMeter(root, streak) {
    var nodes = root.querySelectorAll('[data-moon-meter] span');
    if (!nodes.length) return;
    var filled = Math.max(1, Math.min(nodes.length, Math.ceil((Number(streak || 1) % 8) || 8)));
    nodes.forEach(function (node, index) {
      node.classList.toggle('is-filled', index < filled);
    });
  }

  function readCollection(key) {
    var parsed = safeJSON(localStorage.getItem(key));
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  }

  function writeCollection(key, values) {
    localStorage.setItem(key, JSON.stringify(Array.from(new Set(values)).slice(0, oracleSigns.length)));
  }

  function markDiscovered(state, result) {
    if (!result || !result.signSlug) return;
    var discovered = readCollection(state.collectionKey);
    if (result.discoveredSigns && Array.isArray(result.discoveredSigns)) {
      discovered = result.discoveredSigns.map(normalizeSignSlug).filter(Boolean);
    }
    if (discovered.indexOf(result.signSlug) < 0) discovered.push(result.signSlug);
    writeCollection(state.collectionKey, discovered);
  }

  function renderCollection(state, result) {
    var root = state.root;
    var discovered = readCollection(state.collectionKey);
    if (result && result.discoveredSigns && Array.isArray(result.discoveredSigns)) {
      discovered = result.discoveredSigns.map(normalizeSignSlug).filter(Boolean);
      if (result.signSlug && discovered.indexOf(result.signSlug) < 0) discovered.push(result.signSlug);
      writeCollection(state.collectionKey, discovered);
    }
    var unique = Array.from(new Set(discovered));
    setText(root, '[data-collection-count]', unique.length + '/' + oracleSigns.length + ' discovered');
    var grid = root.querySelector('[data-oracle-collection]');
    if (!grid) return;
    grid.innerHTML = oracleSigns.map(function (sign) {
      var found = unique.indexOf(sign.slug) >= 0;
      return '<span class="ksf-v5__sign-token' + (found ? ' is-found' : '') + '" data-sign="' + escapeHTML(sign.slug) + '" title="' + escapeHTML(found ? sign.name : 'Undiscovered Skin Sign') + '">' + (found ? sign.symbol : '·') + '</span>';
    }).join('');
  }

  function resolveOracleSign(source, tier) {
    var raw = source.sign || source.skin_sign || source.skinSign || source.oracle_sign || source.oracleSign || source.label || '';
    if (tier === 'bluemoon' || tier === 'blue-moon') raw = raw || 'rare-moon';
    var sign = signFromName(raw);
    if (sign) return sign;
    var text = String((source.message || '') + ' ' + (source.mission || '')).toLowerCase();
    if (text.indexOf('night') >= 0 || text.indexOf('pm') >= 0) return signFromName('night');
    if (text.indexOf('hydrate') >= 0 || text.indexOf('water') >= 0) return signFromName('drink');
    if (text.indexOf('barrier') >= 0 || text.indexOf('shield') >= 0) return signFromName('shield');
    if (text.indexOf('calm') >= 0 || text.indexOf('rest') >= 0) return signFromName('calm');
    if (text.indexOf('glow') >= 0 || text.indexOf('bright') >= 0) return signFromName('glow');
    return oracleSigns[Math.abs(hashCode(String(source.label || tier || 'reset'))) % oracleSigns.length];
  }

  function signFromName(value) {
    var slug = normalizeSignSlug(value);
    for (var i = 0; i < oracleSigns.length; i += 1) {
      if (oracleSigns[i].slug === slug || normalizeSignSlug(oracleSigns[i].name) === slug) return oracleSigns[i];
    }
    return null;
  }

  function normalizeSignSlug(value) {
    var input = String(value || '').toLowerCase().replace(/^the\s+/, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    if (!input) return '';
    if (input === 'calm-drop' || input === 'blue-pause') return 'calm';
    if (input === 'quiet-barrier' || input === 'soft-shield') return 'shield';
    if (input === 'slow-glow' || input === 'bright-dew') return 'glow';
    if (input === 'fresh-start') return 'fresh';
    if (input === 'rare' || input === 'blue-moon' || input === 'bluemoon') return 'rare-moon';
    return input;
  }

  function hashCode(value) {
    var hash = 0;
    for (var i = 0; i < value.length; i += 1) {
      hash = ((hash << 5) - hash) + value.charCodeAt(i);
      hash |= 0;
    }
    return hash;
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function readStreak(key) {
    var parsed = safeJSON(localStorage.getItem(key)) || {};
    return {
      lastPlayDate: parsed.lastPlayDate || '',
      streakCount: Number(parsed.streakCount || 0),
      longestStreak: Number(parsed.longestStreak || 0)
    };
  }

  function getPendingStreak(streak, today) {
    if (streak.lastPlayDate === today) return streak.streakCount || 1;
    if (isYesterday(streak.lastPlayDate, today)) return (streak.streakCount || 0) + 1;
    if (streak.lastPlayDate && !isYesterday(streak.lastPlayDate, today)) {
      return 1;
    }
    return 1;
  }

  function isYesterday(dateKey, today) {
    if (!dateKey) return false;
    return dateDiff(dateKey, today) === 1;
  }

  function dateDiff(fromKey, toKey) {
    var from = localDate(fromKey);
    var to = localDate(toKey);
    if (!from || !to) return 999;
    return Math.round((to.getTime() - from.getTime()) / 86400000);
  }

  function localDate(key) {
    var parts = String(key || '').split('-').map(Number);
    if (parts.length !== 3 || parts.some(isNaN)) return null;
    return new Date(parts[0], parts[1] - 1, parts[2]);
  }

  function updateDate(root, key) {
    setText(root, '[data-ticket-date]', key.replace(/-/g, '.'));
  }

  function updateCountdown(root) {
    var node = root.querySelector('[data-reset-countdown]');
    var short = countdownShort(root);
    if (node) node.textContent = 'resets in ' + short;
    var tomorrow = root.querySelector('[data-tomorrow-button]');
    if (tomorrow && (root.classList.contains('is-revealed') || root.classList.contains('is-locked'))) {
      tomorrow.textContent = 'Come back tomorrow · ' + short;
    }
    if (root.classList.contains('is-locked')) {
      var ticket = root.querySelector('[data-ticket-streak]');
      var count = root.querySelector('[data-streak-count]') ? root.querySelector('[data-streak-count]').textContent : '';
      if (ticket && count) ticket.textContent = count + ' streak 🔥 · Next pull in ' + short;
    }
  }

  function countdownShort() {
    var root = arguments.length ? arguments[0] : null;
    var now = new Date();
    var iso = root && root.getAttribute ? root.getAttribute('data-next-reset-iso') : '';
    var end = iso ? new Date(iso) : new Date(now);
    if (!iso) end.setHours(24, 0, 0, 0);
    if (isNaN(end.getTime())) {
      end = new Date(now);
      end.setHours(24, 0, 0, 0);
    }
    var diff = Math.max(0, end.getTime() - now.getTime());
    var hours = Math.floor(diff / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);
    return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
  }

  function milestoneText(streak) {
    if (streak >= 30) return '30-day streak — a full-size is on the way. 🌙';
    if (streak >= 7) return '7-day streak — mini-reward odds boosted.';
    if (streak >= 3) return '3-day streak — better point odds today.';
    return '3 days unlocks a softer reward path.';
  }

  function hintFor(percent) {
    for (var i = 0; i < scratchHints.length; i += 1) {
      if (percent <= scratchHints[i].max) return scratchHints[i].text;
    }
    return scratchHints[scratchHints.length - 1].text;
  }

  function rewardNote(result, locked) {
    /* S1102: one fortune per household per day (server sets household_limited) */
    if (result.household) return 'One fortune per household each day — come back after midnight (PT) for yours.';
    var prefix = locked ? 'Already opened today. ' : '';
    if (result.rewardKind === 'points') {
      if (result.rewardStatus === 'fulfilled') return prefix + 'Added to your Joy balance ✨ Redeem points for your next Klairs order.';
      return prefix + rewardDisplay(result.rewardKind, result.points, result.rewardDetail) + ' is pending. Redeem points for your next Klairs order.';
    }
    if (result.rewardKind === 'miniature') {
      return prefix + 'One-time code, valid for 3 days. U.S. shipping. Enjoy the glow.';
    }
    if (result.rewardKind === 'fullsize') {
      return prefix + 'A full-size, on us' + (result.rewardDetail ? ' — ' + result.rewardDetail : '') + '. Code valid for 3 days.';
    }
    if (result.requiresLogin) return prefix + 'Your fortune is ready — log in to keep it and claim.';
    return prefix + 'Come back tomorrow — streaks unlock better odds.';
  }

  function syncServerStreak(state, streak, playedToday) {
    state.streak = normalizeStreakObject(streak, state.today, state.streak.longestStreak);
    if (state.streak.streakCount > 0 && !playedToday && state.streak.lastPlayDate === state.today) {
      state.streak.lastPlayDate = offsetDateKey(-1);
    }
    state.pendingStreak = getPendingStreak(state.streak, state.today);
  }

  function normalizeStreakObject(streak, today, fallbackLongest) {
    var count = serverStreakCount(streak);
    var longest = Number(streak && (streak.longestStreak || streak.longest_streak || streak.longest) || fallbackLongest || count || 0);
    var last = streak && (streak.lastPlayDate || streak.last_play_date || streak.last_played_date);
    return {
      lastPlayDate: last || (count > 0 ? today : ''),
      streakCount: count,
      longestStreak: Math.max(longest, count)
    };
  }

  function serverStreakCount(streak) {
    if (typeof streak === 'number') return streak;
    if (!streak) return 0;
    return Number(streak.streakCount || streak.streak_count || streak.count || streak.current || 0);
  }

  function titleize(value) {
    return String(value || 'Skin Note')
      .replace(/[-_]+/g, ' ')
      .replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function updateShopLink(root, url) {
    var shop = root.querySelector('[data-shop-link]');
    if (shop && url) shop.setAttribute('href', url);
  }

  function updateRewardActions(root, result) {
    var shop = root.querySelector('[data-shop-link]');
    var claim = root.querySelector('[data-claim-link]');
    if (shop) {
      if ((result.rewardKind === 'miniature' || result.rewardKind === 'fullsize') && result.rewardUrl) {
        shop.textContent = result.rewardKind === 'fullsize' ? 'Claim your full-size →' : 'Redeem free mini →';
        shop.setAttribute('href', result.rewardUrl);
      } else {
        shop.textContent = 'Shop best-sellers →';
        shop.setAttribute('href', result.rewardUrl || '/collections/all');
      }
    }
    if (claim) {
      claim.textContent = 'Log in / Sign up';
    }
  }

  function shareFortune(root, button) {
    var sign = root.querySelector('[data-skin-sign]') ? root.querySelector('[data-skin-sign]').textContent.trim() : 'Skin Fortune';
    var message = root.querySelector('[data-fortune-text]') ? root.querySelector('[data-fortune-text]').textContent.trim() : 'Open today’s skin fortune.';
    var text = sign + ' — ' + message;
    if (navigator.share) {
      navigator.share({ title: 'My Klairs Skin Fortune', text: text, url: window.location.href }).catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text + ' ' + window.location.href).then(function () {
        button.classList.add('is-saved');
        button.textContent = 'Copied fortune link';
      }).catch(function () {
        button.textContent = 'Fortune ready to share';
      });
      return;
    }
    button.textContent = 'Fortune ready to share';
  }

  function normalizeTier(value) {
    return String(value || 'common').toLowerCase().replace(/[_\s]+/g, '-').replace('blue-moon', 'bluemoon');
  }

  function normalizeRewardKind(kind, tier) {
    var value = String(kind || '').toLowerCase();
    if (value === 'points' || value === 'miniature' || value === 'fullsize' || value === 'none') return value;
    if (tier === 'sample') return 'miniature';
    if (tier === 'lucky5' || tier === 'lucky10' || tier === 'bluemoon') return 'points';
    if (tier === '30-day' || tier === 'fullsize') return 'fullsize';
    return 'none';
  }

  function rewardDisplay(kind, points, detail) {
    if (kind === 'points') return '+' + Number(points || 0) + ' Joy points';
    if (kind === 'miniature') return 'You won a free mini 🎁' + (detail ? ' — ' + detail : '');
    if (kind === 'fullsize') return detail ? '30-day glow milestone 🌙 — ' + detail : '30-day glow milestone 🌙';
    return "Today's note";
  }

  function createBurst(root, count) {
    var old = root.querySelector('.ksf-v5__burst');
    if (old) old.remove();
    var burst = document.createElement('div');
    burst.className = 'ksf-v5__burst';
    for (var i = 0; i < count; i += 1) {
      var particle = document.createElement('span');
      particle.className = 'ksf-v5__particle';
      var angle = Math.random() * Math.PI * 2;
      var distance = 120 + Math.random() * 170;
      particle.style.setProperty('--x', Math.cos(angle) * distance + 'px');
      particle.style.setProperty('--y', Math.sin(angle) * distance + 'px');
      particle.style.animationDelay = Math.random() * 160 + 'ms';
      burst.appendChild(particle);
    }
    root.querySelector('[data-ticket]').appendChild(burst);
    window.setTimeout(function () { burst.remove(); }, 1500);
  }

  function setTicketState(root, text) {
    setText(root, '[data-ticket-state]', text);
  }

  function setStageCopy(root, text) {
    setText(root, '[data-stage-copy]', text);
  }

  function setText(root, selector, text) {
    var node = root.querySelector(selector);
    if (node) node.textContent = text;
  }

  function todayKey() {
    var now = new Date();
    return now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
  }

  function offsetDateKey(days) {
    var date = new Date();
    date.setDate(date.getDate() + days);
    return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
  }

  function pick(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  function safeJSON(value) {
    try {
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  }

  function emit(root, name, payload) {
    var eventName = name.indexOf('skin_fortune_') === 0 ? name : 'skin_fortune_' + name;
    var data = payload || {};
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push(Object.assign({ event: eventName }, data));
    }
    root.dispatchEvent(new CustomEvent(eventName, { detail: data }));
  }

  function suppressRewardOverlays() {
    [
      '#Avada-Joy_FloatingButton',
      '.Avada-Preview__ReferralCard',
      '.Avada-Joy_ButtonWidget',
      '.joy-points-calculator__block--embed'
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        node.style.setProperty('display', 'none', 'important');
        node.style.setProperty('visibility', 'hidden', 'important');
        node.style.setProperty('pointer-events', 'none', 'important');
      });
    });
  }

  function vibrate(pattern) {
    if (navigator.vibrate) navigator.vibrate(pattern);
  }

  function injectSkinReadinessFallback(root) {
    if (!root || document.querySelector('[data-skin-readiness]')) return;

    injectSkinReadinessStyles();

    var section = document.createElement('section');
    section.className = 'ksr blocks-radius ksr--fortune';
    section.setAttribute('data-skin-readiness', '');
    section.setAttribute('aria-labelledby', 'SkinReadinessTitle-fortune');
    section.innerHTML = [
      '<div class="ksr__head">',
      "<p class=\"ksr__eyebrow\">TODAY'S SKIN READINESS</p>",
      "<h2 id=\"SkinReadinessTitle-fortune\">Choose today's routine in 3 taps.</h2>",
      '<p>Not a diagnosis. Just a quick self-check to help you decide whether to keep your routine normal, light, or extra gentle today.</p>',
      '</div>',
      '<div class="ksr__body" data-ksr-body>',
      readinessQuestion('tightness', '01', 'Does your skin feel tight?', 'Skin tightness', [
        ['0', 'Comfortable'],
        ['1', 'Slightly tight'],
        ['2', 'Very tight']
      ]),
      readinessQuestion('reaction', '02', 'Any warmth, stinging, or visible redness?', 'Skin reaction', [
        ['0', 'No'],
        ['1', 'A little'],
        ['2', 'Noticeable']
      ]),
      readinessQuestion('active', '03', 'Did you use a strong active yesterday?', 'Recent active use', [
        ['1', 'Yes'],
        ['0', 'No']
      ]),
      '</div>',
      '<div class="ksr__result" data-ksr-result hidden aria-live="polite">',
      "<p class=\"ksr__result-label\">Today's Skin Readiness</p>",
      '<h3 data-ksr-title>Keep it light.</h3>',
      '<p data-ksr-copy>Cleanse gently, add hydration, and pause before another active today.</p>',
      '<div class="ksr__links">',
      '<a href="/products/supple-preparation-unscented-toner" data-ksr-link-primary>Shop a gentle prep step</a>',
      '<a href="/blogs/klairs-skin-school/how-to-choose-face-mist" data-ksr-link-secondary>Read the Skin School guide</a>',
      '</div>',
      "<button type=\"button\" class=\"ksr__reset\" data-ksr-reset>Retake today's check</button>",
      '</div>'
    ].join('');

    root.insertAdjacentElement('afterend', section);
    initSkinReadinessWidget(section);
  }

  function readinessQuestion(key, number, title, label, options) {
    return [
      '<div class="ksr__question" data-question="' + key + '">',
      '<span class="ksr__number">' + number + '</span>',
      '<div>',
      '<h3>' + title + '</h3>',
      '<div class="ksr__options" role="group" aria-label="' + label + '">',
      options.map(function (option) {
        return '<button type="button" data-score="' + option[0] + '">' + option[1] + '</button>';
      }).join(''),
      '</div>',
      '</div>',
      '</div>'
    ].join('');
  }

  function initSkinReadinessWidget(widget) {
    var key = 'klairsSkinReadiness:' + new Date().toISOString().slice(0, 10);
    var states = {
      ready: {
        title: 'Ready.',
        copy: 'Your skin sounds comfortable today. Keep your usual routine, and use actives only if they already fit your skin.',
        primary: 'Shop best-sellers',
        primaryHref: '/collections/all',
        secondary: 'Read about daily misting',
        secondaryHref: '/blogs/klairs-skin-school/how-to-choose-face-mist'
      },
      light: {
        title: 'Keep it light.',
        copy: 'Cleanse gently, add hydration, and pause before another active today.',
        primary: 'Shop Unscented Toner',
        primaryHref: '/products/supple-preparation-unscented-toner',
        secondary: 'Read the gentle routine guide',
        secondaryHref: '/blogs/klairs-skin-school/how-to-choose-face-mist'
      },
      recovery: {
        title: 'Recovery day.',
        copy: 'Choose the fewest comfortable steps: calm, hydrate, seal, and save strong actives for another day.',
        primary: 'Shop Blue EGF Mist',
        primaryHref: '/products/blue-egf-cooling-mist',
        secondary: 'Explore Blue Line',
        secondaryHref: '/collections/blue-line'
      }
    };
    var answers = {};
    var result = widget.querySelector('[data-ksr-result]');
    var stored = safeJSON(localStorage.getItem(key));
    if (stored && stored.state) {
      answers = stored.answers || {};
      Object.keys(answers).forEach(function (question) {
        var selected = widget.querySelector('[data-question="' + question + '"] [data-score="' + answers[question] + '"]');
        if (selected) selected.classList.add('is-selected');
      });
      renderSkinReadiness(widget, states[stored.state]);
    }
    widget.addEventListener('click', function (event) {
      var option = event.target.closest('[data-score]');
      if (option) {
        var question = option.closest('[data-question]');
        if (!question) return;
        question.querySelectorAll('[data-score]').forEach(function (button) {
          button.classList.toggle('is-selected', button === option);
        });
        answers[question.getAttribute('data-question')] = Number(option.getAttribute('data-score'));
        if (answers.tightness !== undefined && answers.reaction !== undefined && answers.active !== undefined) {
          var state = calculateSkinReadiness(answers);
          localStorage.setItem(key, JSON.stringify({ state: state, answers: answers }));
          renderSkinReadiness(widget, states[state]);
        }
      }
      if (event.target.closest('[data-ksr-reset]')) {
        answers = {};
        localStorage.removeItem(key);
        widget.querySelectorAll('.is-selected').forEach(function (node) { node.classList.remove('is-selected'); });
        if (result) result.hidden = true;
      }
    });
  }

  function calculateSkinReadiness(answers) {
    var score = Number(answers.tightness || 0) + Number(answers.reaction || 0) + Number(answers.active || 0);
    if (Number(answers.reaction) >= 2 || score >= 4) return 'recovery';
    if (score >= 2) return 'light';
    return 'ready';
  }

  function renderSkinReadiness(widget, state) {
    var result = widget.querySelector('[data-ksr-result]');
    if (!result || !state) return;
    setText(widget, '[data-ksr-title]', state.title);
    setText(widget, '[data-ksr-copy]', state.copy);
    var primary = widget.querySelector('[data-ksr-link-primary]');
    var secondary = widget.querySelector('[data-ksr-link-secondary]');
    if (primary) {
      primary.textContent = state.primary;
      primary.href = state.primaryHref;
    }
    if (secondary) {
      secondary.textContent = state.secondary;
      secondary.href = state.secondaryHref;
    }
    result.hidden = false;
  }

  function injectSkinReadinessStyles() {
    if (document.getElementById('klairs-skin-readiness-styles')) return;
    var style = document.createElement('style');
    style.id = 'klairs-skin-readiness-styles';
    style.textContent = '.ksr{margin:1.6rem 0;padding:2.2rem;border:1px solid #d9ecff;background:linear-gradient(135deg,#f4fbff 0%,#fff 66%,#f8fbf4 100%);color:#10243b;box-shadow:0 .8rem 2.4rem rgba(47,131,201,.08)}.ksr--fortune{width:min(112rem,calc(100% - 3.2rem));margin:2.4rem auto 0}.ksr *{box-sizing:border-box}.ksr__head{max-width:72rem}.ksr__eyebrow{margin:0 0 .55rem;color:#147fd1;font-size:1.1rem;font-weight:850;letter-spacing:0}.ksr__head h2{margin:0;color:#10243b;font-size:clamp(2.2rem,3vw,3.6rem);line-height:1.08;letter-spacing:0}.ksr__head p,.ksr__result p{margin:.8rem 0 0;color:#52637a;font-size:1.35rem;line-height:1.55}.ksr__body{display:grid;gap:1rem;margin-top:1.8rem}.ksr__question{display:grid;grid-template-columns:auto minmax(0,1fr);gap:1.2rem;padding:1.4rem;border:1px solid #e4f0fb;border-radius:1.6rem;background:rgba(255,255,255,.76)}.ksr__number{display:grid;place-items:center;width:3.8rem;height:3.8rem;border-radius:1.3rem;background:#e4f4ff;color:#147fd1;font-size:1.2rem;font-weight:850}.ksr__question h3{margin:0 0 .9rem;color:#10243b;font-size:1.45rem;line-height:1.25}.ksr__options{display:flex;flex-wrap:wrap;gap:.7rem}.ksr__options button{appearance:none;border:1px solid #cfe8ff;border-radius:999px;background:#fff;color:#244058;min-height:3.8rem;padding:.8rem 1.35rem;font:inherit;font-size:1.25rem;font-weight:750;line-height:1.1;cursor:pointer}.ksr__options button.is-selected{border-color:#147fd1;background:#147fd1;color:#fff}.ksr__result{margin-top:1.6rem;padding:1.7rem;border-radius:1.8rem;border:1px solid #bfe0ff;background:#fff}.ksr__result-label{margin:0 0 .4rem!important;color:#147fd1!important;font-size:1.1rem!important;font-weight:850;letter-spacing:0;text-transform:uppercase}.ksr__result h3{margin:0;color:#10243b;font-size:clamp(2rem,2.3vw,2.8rem);line-height:1.12}.ksr__links{display:flex;flex-wrap:wrap;gap:.8rem;margin-top:1.4rem}.ksr__links a,.ksr__reset{display:inline-flex;align-items:center;justify-content:center;min-height:4.2rem;border-radius:999px;padding:.9rem 1.6rem;font-size:1.25rem;font-weight:800;text-decoration:none;line-height:1.1}.ksr__links a:first-child{background:#10243b;color:#fff}.ksr__links a:nth-child(2),.ksr__reset{border:1px solid #cfe8ff;background:#eef8ff;color:#147fd1}.ksr__reset{margin-top:1rem;cursor:pointer;font-family:inherit}@media screen and (max-width:749px){.ksr,.ksr--fortune{width:auto;margin:1.4rem 0;padding:1.8rem}.ksr__question{grid-template-columns:1fr;gap:1rem}.ksr__number{width:auto;height:auto;min-height:3.2rem;justify-self:start;padding:.55rem 1rem}.ksr__options,.ksr__links{display:grid;grid-template-columns:1fr}.ksr__options button,.ksr__links a,.ksr__reset{width:100%}}';
    document.head.appendChild(style);
  }
})();
